export default __webpack_public_path__ + "static/home_intro-720-b0c53824e0c7f09b3df664cd448c0012.mp4";